import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Box, Grid, Pagination, CircularProgress } from "@mui/material";
// import CustomTable from "components/CustomTable";
import { useRecoilState } from "recoil";
import { selectedButtonState, totalCountState } from "../../recoil/index.ts";
import { useNavigate } from "react-router-dom";
import MouseClickList from "../MouseClickList.tsx";
import { getInspRule, deleteInspRule } from "../../services/inspRuleService.js";

export default function InspRuleTable({
  setCount,
  setOpenModal,
  receivedData,
  setReceivedData,
  total,
  page,
  setPage,
  setSelectedModelInfo,
  keyword,
}) {
  const [selectedButton, setSelectedButton] = useRecoilState(selectedButtonState);
  const [totalItems, setTotalItems] = useRecoilState(totalCountState);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDatas();
  }, [keyword, page]);

  useEffect(() => {
    setSelectedButton("규칙");
  }, []);

  const fetchDatas = async () => {
    try {
      setIsLoading(true);
      const { extractedData, totalItems } = await getInspRule({
        page: page,
        size: 20,
        keyword,
      });
      setReceivedData(extractedData);
      setCount(totalItems);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "No.",
      width: 100,
    },
    {
      field: "description",
      headerName: "Rule Info",
      width: 100,
    },
    {
      field: "model_name",
      headerName: "Model",
      width: 250,
    },
    {
      field: "model_description",
      headerName: "Model Description",
      width: 200,
    },
    {
      field: "recipe_regex",
      headerName: "Recipe",
      width: 150,
    },
    {
      field: "image_regex",
      headerName: "FileName",
      width: 150,
    },
  ];

  const handleEdit = () => {
    navigate(`/insp-rule/${selectedModelId}`);
  };

  const handleDelete = async (row) => {
    try {
      if (window.confirm("정말 삭제하시겠습니까?")) {
        await deleteInspRule(selectedModelId);
        const { extractedData, totalItems } = await getInspRule({
          page: page,
          size: 10,
        });
        setReceivedData(extractedData);
        setCount(totalItems);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDetailClick = async (params) => {
    try {
      setOpenModal(true);
      setSelectedModelInfo(params.row);
    } catch (error) {
      console.error(error);
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    const selectedModelId = event.currentTarget.getAttribute("data-id");
    setAnchorEl(event.currentTarget);
    setOpen(true);
    setSelectedModelId(Number(selectedModelId));
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Grid container sx={{ mt: 3 }}>
            <DataGrid
              hideFooter
              hideFooterPagination
              disableColumnMenu
              disableColumnSorting
              rows={receivedData}
              columns={columns}
              getRowId={(row) => row.id}
              slotProps={{
                row: {
                  onContextMenu: handleContextMenu,
                  style: { cursor: "context-menu" },
                },
              }}
              onRowClick={handleDetailClick}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-filler": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-virtualScrollerContent": {
                  backgroundColor: "white",
                },
                "& .MuiDataGrid-cell": {
                  cursor: "pointer",
                  backgroundColor: "var(--unselected-row-bg)",
                  color: "var(--dg-color)",
                },
              }}
            />

            <MouseClickList
              anchorEl={anchorEl}
              open={open}
              category="insp_rule"
              // existModuleIds={existModuleIds}
              onClose={handleClose}
              onEdit={handleEdit}
              onDelete={handleDelete}
              // onModuleDelete={handleModuleDelete}
            />
            {/* {isModalOpen && (
                  <TrainModal
                    open={isModalOpen}
                    onClose={handleCloseModal}
                    state={state}
                    selectTrain={selectedTrain}
                  />
                )} */}
          </Grid>
          <Pagination
            count={Math.ceil(total / 20)}
            page={page}
            onChange={(_, value) => setPage(value)}
            color="primary"
            size="medium"
            sx={{ mt: 2, display: "flex", justifyContent: "center" }}
          />
        </Box>
      )}
    </>
  );
}
